import {IURLParameters, URLParameterType} from '@gongxigames/framework/core/types';

export class URLParameters implements IURLParameters {
    private _params: any = {};

    constructor(query: string) {
        this.parseUrlParams(query);
    }

    public getParameter(name: string, type: URLParameterType = 'string'): any {
        const value = this._params[name];

        if (!value) {
            return value;
        }

        switch (type) {
            case 'number': {
                return this.parseNumber(value);
            }
            case 'array': {
                return this.parseArray(value);
            }
            case 'boolean': {
                return this.parseBoolean(value);
            }
            case 'string': {
                return value;
            }
            default: {
                return value;
            }
        }
    }

    public hasParameter(name: string): boolean {
        const value = this._params[name];

        return value !== undefined && value !== '';
    }

    protected parseNumber(value: string): number {
        return Number(value);
    }

    protected parseArray(value: string): string[] {
        return value.split(',');
    }

    protected parseBoolean(value: string): boolean {
        return value.toLowerCase() === 'true';
    }

    private parseUrlParams(query: string): any {
        new URLSearchParams(query).forEach((value, key) => {
            this._params[key] = value;
        });
    }
}
